import { motion } from "framer-motion";

export const Founder = () => {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative bg-[#E8E3DA] py-24 md:py-40 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-16">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.1 }}
          className="col-span-12 md:col-span-5"
        >
          <div className="relative overflow-hidden aspect-square w-full bg-[#3F5043]">
            <img
              src="https://customer-assets.emergentagent.com/job_vision-driven/artifacts/px2kg8yd_Gaurav%20Webiste%20pic.png"
              alt="Gaurav Lulla, founder of FabFathers — Architects of Memories"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] hover:scale-105"
            />
          </div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, delay: 0.15 }}
          className="col-span-12 md:col-span-7 md:pt-8"
        >
          <motion.span
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="font-serif-display text-[100px] md:text-[140px] lg:text-[180px] leading-[0.9] text-[#C06E52]/20 font-light block mb-6 md:mb-8"
          >
            05
          </motion.span>
          <p className="text-[13px] md:text-sm uppercase tracking-[0.28em] text-[#C06E52] font-semibold mb-6">
            {`The Founder's Story`}
          </p>

          <h2
            data-testid="founder-heading"
            className="font-serif-display text-[#2D3730] text-4xl sm:text-5xl lg:text-[60px] leading-[1.08] font-light tracking-tight"
          >
            {`I started `}<span className="italic">FabFathers</span>{` because nobody taught me how to be one.`}
          </h2>

          <div className="mt-10 md:mt-12 space-y-7 text-[#2D3730]/85 text-base md:text-lg leading-relaxed font-light max-w-[640px]">
            <p>
              {`For years, I believed being a good father meant providing well. I worked hard, fulfilled my responsibilities, and made sure my family had everything they needed. But over time, I realised that fatherhood demands more than being a provider—it asks us to be participants in our children's emotional journey. The challenge wasn't a lack of love or intention. I wanted to help my children build confidence, resilience, and emotional well-being. I simply didn't know how. No one had handed me a roadmap for those conversations, those moments of connection, or the everyday habits that shape a child's inner world. That realisation became the beginning of a different journey—one focused not just on raising successful children, but emotionally thriving ones.`}
            </p>

            <blockquote className="border-l-2 border-[#C06E52] pl-6 my-10">
              <p className="font-serif-display italic text-2xl md:text-3xl text-[#2D3730] leading-snug">
                {`"The next generation of children need fathers who are Architects of Memories, Builders of Emotional Routines, and Champions of Mindfulness."`}
              </p>
            </blockquote>

            <p>
              {`FabFathers is the program I needed and could not find. It is built from late nights, hard conversations with my own kids, and the slow, beautiful work of learning that a father's job is not to be the strongest voice in the room — but the safest one.`}
            </p>

            <p>
              {`If you have ever sat outside your child's door, knowing you should knock and not knowing what to say once you do — this is for you.`}
            </p>
          </div>

          <div className="mt-12 md:mt-14 flex items-center gap-5">
            <div className="h-px w-12 bg-[#2D3730]" />
            <div>
              <p className="font-serif-display italic text-xl md:text-2xl text-[#2D3730] leading-tight">
                Gaurav Lulla
              </p>
              <p className="mt-1 text-[11px] uppercase tracking-[0.24em] text-[#8A9A86]">
                Founder, FabFathers
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
